<template>
	<div class="new-field-detail">
		<FieldDetail
			ref="fieldDetail"
			v-model="sourceData"
			:impactList="impactList"
			@focus="addFocus"
			:resetValue="resetValue"
			:rangeValues="rangeValues"
		/>
		<div class="new-field-detail__footer">
			<Button
				ref="addfield"
				className="btn--has-icon"
				placeholder="Select field type"
				:iconBeforeLabel="true"
				iconClassName="icon-more"
				labelText="Add Field"
				:btnClick="addFile"
				:disabled="modelHasError"
				@keyup.enter="addFile"
			/>
		</div>
	</div>
</template>

<script>
import FieldDetail from '@/views/form-designer/field-detail';
import Button from '@/components/forms/button/button';
import { mapGetters } from 'vuex';
import { deepEqual } from '@/utils/object';
import _ from 'lodash';

export default {
	name: 'NewFieldDetail',
	components: {
		FieldDetail,
		Button
	},
	model: {
		prop: 'fieldType',
		event: 'change'
	},
	props: {
		fieldType: {
			type: Object,
			default: () => {}
		},
		impactInputFieldsList: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			impactList: [],
			sourceData: {},
			resetValue: false,
			rangeValues: {
				characterNumber: { minValue: 1, maxValue: 50 },
				dot: { minValue: 0, maxValue: 11 },
				rowCol: { minValue: 0 }
			}
		};
	},
	computed: {
		...mapGetters('codemanager', ['codeSelected']),
		modelHasError() {
			if (_.isEmpty(this.sourceData)) {
				return true;
			}
			const { row, dot, col } = this.sourceData;

			if (
				row === undefined ||
				row === '' ||
				row < _.get(this.rangeValues, 'rowCol.minValue', 0)
			) {
				return true;
			}
			if (
				dot === undefined ||
				dot === '' ||
				dot < _.get(this.rangeValues, 'dot.minValue', 0) ||
				dot > _.get(this.rangeValues, 'dot.maxValue', 11)
			) {
				return true;
			}
			if (
				col === undefined ||
				col === '' ||
				col < _.get(this.rangeValues, 'rowCol.minValue', 0)
			) {
				return true;
			}

			if (this.sourceData.impactType === 'S') {
				return !(
					this.sourceData.staticValue && this.sourceData.description
				);
			}
			if (this.sourceData.impactType === 'I') {
				return !this.sourceData.keyboardPrompt;
			}
			if (this.sourceData.impactType === 'C') {
				if (this.sourceData.truncate) {
					return (
						!this.sourceData.description ||
						this.sourceData.characterNumber <
							_.get(
								this.rangeValues,
								'characterNumber.minValue',
								1
							) ||
						this.sourceData.characterNumber >
							_.get(
								this.rangeValues,
								'characterNumber.maxValue',
								50
							)
					);
				} else {
					return !this.sourceData.description;
				}
			}
			return false;
		}
	},
	methods: {
		addFile() {
			this.$store.dispatch('codemanager/resetSnippet', true);
			this.resetValue = true;
			this.$emit('add', true);

			this.$nextTick(() => {
				this.resetValue = false;
				const input = _.get(
					this,
					'$refs.fieldDetail.$refs.row.$refs.fieldinput',
					null
				);
				if (input) {
					input.focus();
				}
			});
		},
		addFocus(val) {
			if (val) {
				this.$refs.addfield.$el.focus();
			}
		}
	},
	watch: {
		impactInputFieldsList: {
			deep: true,
			immediate: true,
			handler() {
				this.impactList = [...this.impactInputFieldsList];
			}
		},
		sourceData: {
			deep: true,
			handler(obj) {
				this.$emit('change', obj);
			}
		},
		fieldType: {
			deep: true,
			immediate: true,
			handler(val) {
				if (!deepEqual(val, this.sourceData)) {
					this.sourceData = { ...val };
				}
			}
		},
		codeSelected: {
			deep: true,
			handler(val) {
				if (this.sourceData.impactType === 'C') {
					const {
						id,
						description,
						snippetFormat,
						snippetJustify,
						snippetCalc
					} = val || {};
					Object.assign(this.sourceData, {
						formsSnippetsId: id,
						description: description,
						formsSnippetDescription: description,
						format: snippetFormat,
						justify: snippetJustify,
						calc: snippetCalc
					});
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.new-field-detail {
	&__footer {
		display: flex;
		justify-content: flex-end;
		margin-top: $gutter-lg;
	}
}
</style>
